<app-widget-base-detail [baseDetailComponent]="this" [preMenu]="preMenu" />

<ng-template #preMenu>
    @if (linkedEntityEditLink()) {
        <a
            [routerLink]="linkedEntityEditLink()"
            class="p-button p-component p-button-icon-only p-button-secondary p-button-outlined inline-flex items-center justify-center min-w-[2.5rem] min-h-[2.5rem]"
            [pTooltip]="linkedEntityLinkTooltip()"
            [attr.aria-label]="linkedEntityLinkTooltip()"
            data-testid="task-open-related-entity-link"
        >
            <i class="fa fa-external-link-alt"></i>
        </a>
    }
</ng-template>
